<template>
  <div class="row daily-schedule ms-auto" >
    <div class="mb-3" >
      <h3 class="page-title mb-2" style="margin-top: 100px">Daily Crew Schedule</h3>
      
      <div v-permcheck="'DailyCrewSchedule.CrewScheduleGrid.R'" class="buttons-area row justify-content-start" >
        <div class="col-md-6 text-end d-flex justify-content-start mt-5">
          <div class="date-picker-area me-3" ><input id="date-picker" @change="datePickerChanged" v-model="picked"
                                                    class="p-1" type="date"></div>
<!--          <button @click="exportHTML">Export to PDF</button>-->
<!--          <button class="core-save-btn px-3 py-3 mb-3 me-3" type="button" @click="Export_TableToExcel()">Export To Excel <i class="icon icon-download-solid"></i></button>-->

<ManualModal :messageFromParent="picked" :id="selectedManualId" @child-event="runParentMethod" ref="childComponentRef"/>
          <select style="width: 150px; height: 50px; padding-left: 10px; font-size: 18px" v-model="color">
            <option selected disabled value="">Select Color</option>
            <option value="lightblue">Blue</option>
            <option value="pink">Pink</option>
            <option value="gray">Gray</option>
            <option value="lightgreen">Green</option>
            <option value="red">Red</option>
            <option value="orange">Orange</option>
            <option value="yellow">Yellow</option>
            <option value="mediumpurple">Purple</option>
            <option value="teal">Teal</option>
            <option value="gold">Gold</option>
          </select>
          <span class="ms-2 me-3" style="width: 25px; height: 25px; border-radius: 50%; margin-top: 10px" :style="getColor !== '' ? 'background:'+ getColor : 'background: white'"></span>

          
          <button v-permcheck="'DailyCrewSchedule.CrewScheduleGrid.W'" class="core-add-btn px-3 py-3 ms-3 mb-3 me-3" @click="publishForm()">Publish <i class="icon icon-folder-upload"></i>
          </button>
          <button @click="openManualModal()" class="core-add-btn px-3 py-3 mb-3 me-3">Add Manual<i style="font-weight: normal" class="ms-1 icon icon-plus"></i></button>
          <router-link tag="button" to="/DAI-Gendec/last-revisions" class="core-save-btn px-3 py-3 mb-3">Revisions <i style="font-weight: normal" class="icon-eye"></i> </router-link>
          
        </div>

      </div>
      <div id="publish-modal" class="modal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content pb-0">
            <div class="modal-header">
              <h5 class="modal-title">Publish Confirm</h5>
              <button @click="publishModalClose" id="publish-close" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p class="text-start publish-text">You are about the Publish the Revision. <strong>REV.{{this.lastRev + 1}} </strong> Do you want to continue ?</p>
            </div>
            <div class="modal-footer">
              <button @click="publishModalClose" id="publish-close" type="button" class="core-close-btn rounded-1" data-bs-dismiss="modal">No</button>
              <button @click="publishConfirm" type="button" class="core-save-btn rounded-1">Yes</button>
            </div>
          </div>
        </div>
      </div>

      
      <div v-permcheck="'DailyCrewSchedule.CrewScheduleGrid.R'" id="myModal" class="modal" >
        <div class="modal-content">
          <div v-if="getData!=[] && getData.length>0" @click="closeModal" class="close text-end">&times;</div>
          <div class="text-start"><h4 class="edit-title mb-0">Edit</h4></div>
          <hr>
          <div class="employee-area" style="height: 500px; overflow: auto; overflow-x: hidden;">
            <table v-if="manualCrew.length > 0" class="table table-striped mt-5">
              <thead>
              <th>Name</th>
              <th>TLC</th>
              <th class="text-center me-3">Delete</th>
              </thead>
              <tbody>
              <tr v-for="(manual,index) in manualCrew" :key="index">
                <td style="font-size: 16px">{{manual.FULLNAME}}</td>
                <td style="font-size: 16px">{{manual.TLC}}</td>
                <td class="text-center"><button @click="deleteByID(manual)" class="core-close-btn">Delete</button></td>
              </tr>
              </tbody>
            </table>
            <br><br>
            <div class="row">
              <div class="col-md-4 row justify-content-start">
                <div class="text-start col-md-6 w-100" style=""><input style="padding: .75rem; text-transform: uppercase" class="form-control w-100" v-model="search" placeholder="Search"></div>

              </div>
              <div class="col-md-8 text-start row pe-0">
                <div class="col-md-11">
                  <input style="padding: .75rem; width: 100%" class="form-control" v-model="Remark" placeholder="Remark">
                </div>
                <div class="col-md-1 text-end pe-0">
                  <button @click="sendRemark" class="core-add-btn rounded-1 btn-manual-add">ADD</button>
                </div>
              </div>
            </div>

            <table class="table table-bordered table-striped table-scroll core-table table-hover mt-5">
              <thead>
                <th>Name</th>
                <th>Surname</th>
                <th>Department</th>
                <th>Detail</th>
                <th>Action</th>
              </thead>
              <tbody>
                <tr v-for="(item,index) in filteredData" :key="index+1000">
                  <td >{{item.Adi}}</td>
                  <td >{{item.Soyadi}}</td>
                  <td >{{item.AltBirimIsim}}</td>
                  <td v-if="item.ISCOCKPIT">Cockpit</td>
                  <td v-if="item.ISCABIN">Cabin</td>
                  <td v-if="item.ISTECHNIC">Technic</td>
                  <td v-if="item.ISOTHER">Other</td>
                  <td><button @click="sendData(item)" class="core-add-btn rounded-1">ADD</button></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="employee-status alert" role="alert">
          </div>
          <div class="delete-status alert" role="alert">
          </div>
        </div>
      </div>
      <div class="publish-status alert" role="alert">
      </div>
      
      
      <table v-permcheck="'DailyCrewSchedule.CrewScheduleGrid.R'" id="daily-table" class="table table-striped left-table"
             style="width: 1650px; vertical-align: middle; text-align: center; font-family: Arial; font-size: 11px; border: 1px solid black; page-break-before: always">
        <tr style="vertical-align: middle; font-family: NunitoBold; font-size: 20px; height: 60px;vertical-align: middle; text-align: center;page-break-before: always; page-break-after: always">
          <td style="height: 75px; border: 1px solid black; border-right: unset; background-color: white;vertical-align: middle;text-align: center" colspan="3">
            <img style="width: 120px; text-align: center; vertical-align: center; padding: 0" src="https://crewbox.corendonairlines.com/img/cr_logo_excel.png" alt="Corendon"></td>
          <td style="background-color: white; border-top: 1px solid black; border-bottom: 1px solid black"
              colspan="1"></td>
          <td style="background-color: white; border: 1px solid black; border-left: unset;" colspan="8">CORENDON
            AIRLINES - Daily Crew Schedule / Günlük Ekip Programı / REV.{{lastRev}}
          </td>
          <td style="border: 1px solid black; background-color: white; width: 120px; font-size: 20px; font-weight: bold" colspan="1">
            {{this.showDate}}
          </td>
<!--          <td id="revision-id" style="border: 1px solid black; background-color: white; width: 100px;" colspan="1" rowspan="1">REV.{{lastRev}}
          </td>-->
        </tr>
        <tr style="font-family: NunitoBold; height: 60px;vertical-align: middle;text-align: center">
          <td colspan="6" style="font-size: 18px; border: 1px solid black; background-color: antiquewhite">FLIGHT INFORMATION / UÇUŞ BİLGİSİ
          </td>
          <td style=" border: 1px solid black;border-top: unset">&nbsp;</td>
          <td colspan="7" style="font-size: 18px; border: 1px solid black; background-color: antiquewhite">CREW LIST / EKİP LİSTESİ
          </td>
        </tr>
        <tr style="font-size: 16px; color: darkred; height: 50px; font-family: NunitoBold; vertical-align: middle;text-align: center">
          <td style="font-weight: bold; border: 1px solid black;color: darkred; width: 75px">REG</td>
          <td style="font-weight: bold; border: 1px solid black;color: darkred; width: 100px">Flight Number</td>
          <td style="font-weight: bold; border: 1px solid black;color: darkred; width: 50px">Dep</td>
          <td style="font-weight: bold; border: 1px solid black;color: darkred; width: 50px">Arr</td>
          <td style="font-weight: bold; border: 1px solid black;color: darkred; width: 50px">Std</td>
          <td style="font-weight: bold; border: 1px solid black;color: darkred; width: 50px">Sta</td>
          <td style="font-weight: bold; border: 1px solid black;color: darkred"></td>
          <td colspan="2">&nbsp;</td>
        </tr>
        <tr style="font-size: 12px; height: 45px; border: 1px solid black; vertical-align: middle;text-align: center;" v-for="(item) in getData.filter(x => x.Flights[0].DATATYPE === '1')" :key="item.Flights[0].LEGNO" :id="item.Flights[0].REG">
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" :id="`${item.Flights[0].LEGNO}`" :style="!item.CrewGroups ? 'background: #ccdceb; cursor: pointer' : ''" @click="openModal(item)" >{{item.Flights[0].REG}} <strong :id="item.ID" class="d-none" style="background: none"></strong></td>
          <td :style="item.Flights[0].LAST_REVACTION_FLT === '3' ? 'background: yellow' : item.Flights[0].LAST_REVACTION_FLT === '2' ? 'background: lightgreen' : item.Flights[0].LAST_REVACTION_FLT === '1' ? 'background: black; color: white' : 'background: white'" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].CARRIER}}-{{item.Flights[0].FNO}}</td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleDep($event, item)" :id="`${item.Flights[0].LEGNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].DEP_COLOR === '1' ? 'background: lightblue' : item.Colors[0].DEP_COLOR === '2' ? 'background: pink' : item.Colors[0].DEP_COLOR === '3' ? 'background-color: gray' : item.Colors[0].DEP_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].DEP_COLOR === '5' ? 'background: red' : item.Colors[0].DEP_COLOR === '6' ? 'background: orange':item.Colors[0].DEP_COLOR === '7' ? 'background: yellow' : item.Colors[0].DEP_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].DEP_COLOR === '9' ? 'background: teal' : item.Colors[0].DEP_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].DEP}}
          </td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleArr($event, item)" :id="`${item.Flights[0].LEGNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].ARR_COLOR === '1' ? 'background: lightblue' : item.Colors[0].ARR_COLOR === '2' ? 'background: pink' : item.Colors[0].ARR_COLOR === '3' ? 'background-color: gray' : item.Colors[0].ARR_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].ARR_COLOR === '5' ? 'background: red' : item.Colors[0].ARR_COLOR === '6' ? 'background: orange':item.Colors[0].ARR_COLOR === '7' ? 'background: yellow' : item.Colors[0].ARR_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].ARR_COLOR === '9' ? 'background: teal' : item.Colors[0].ARR_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].ARR}}
          </td>
          <td :style="item.Flights[0].LAST_ATD_ACT === '3' ? 'background: yellow' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STD.substring(11,16)}}</td>
          <td :style="item.Flights[0].LAST_ATA_ACT === '3' ? 'background: yellow' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STA.substring(11,16)}}</td>
          <td style="font-weight: bold; border: 1px solid black; color: darkred;"></td>
          <td colspan="6"  @click="prepareEdit(item)" style="cursor: pointer;">
            <table v-for="(crew,index) in item.CrewGroups" :key="index">
              <tr>
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black;color: white;color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black;border-bottom: 1px solid black;" v-for="(el,j) in crew" :key="j + item.ID + 514588">{{el.CREW}}</td>
              </tr>
            </table>
            <table v-for="(manual,index) in item.CrewManualGroups" :key="index + 878651">
              <tr style="border-top: 1px solid black;">
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black; color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black; border-bottom: 1px solid black; font-style: italic;" v-for="(el,j) in manual" :key="j+ item.ID + 51484"><i class="icon icon-pencil"></i> {{el.FULLNAME}}</td>
              </tr>
            </table>
            <table :style="!item.CrewGroups[0] ? 'width: 50%' : ''">
              <tr>
                <td :colspan="!item.CrewGroups[0] ? 4 : 1" style="width: 165px; text-align: start; vertical-align: middle; height: 45px; border-right: 1px solid black; border-top: 1px solid black;border-bottom: 1px solid black; font-style: italic; font-size: 14px" v-for="(remark,index) in item.Remarks" :key="index + 84563"><i class="icon icon-pencil"></i> {{remark.REMARK}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="height: 50px;vertical-align: middle;text-align: center">
          <td colspan="6"
              style="font-size: 18px; background-color: antiquewhite; font-family: NunitoBold; border: 1px solid black">
            SIMULATORS
          </td>
          <td colspan="1" style=""></td>
          <td colspan="7"
              style="font-size: 18px;background-color: antiquewhite; font-family: NunitoBold;border: 1px solid black">
            CREW LIST / EKİP LİSTESİ
          </td>
        </tr>
        <tr style="font-size: 12px; height: 45px; border: 1px solid black; vertical-align: middle;text-align: center;" v-for="(item) in getData.filter(x => x.Flights[0].DATATYPE === '2' && x.Flights[0].ITDTYPE === 'S')" :key="item.Flights[0].UNO">
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" :id="`${item.Flights[0].UNO}`" :style="!item.CrewGroups ? 'background: #ccdceb; cursor: pointer' : ''" @click="openModal(item)" >{{item.Flights[0].REG}} <strong :id="item.ID" class="d-none" style="background: none"></strong></td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].CODE}}</td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleDep($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].DEP_COLOR === '1' ? 'background: lightblue' : item.Colors[0].DEP_COLOR === '2' ? 'background: pink' : item.Colors[0].DEP_COLOR === '3' ? 'background-color: gray' : item.Colors[0].DEP_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].DEP_COLOR === '5' ? 'background: red' : item.Colors[0].DEP_COLOR === '6' ? 'background: orange':item.Colors[0].DEP_COLOR === '7' ? 'background: yellow' : item.Colors[0].DEP_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].DEP_COLOR === '9' ? 'background: teal' : item.Colors[0].DEP_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].DEP}}
          </td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleArr($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].ARR_COLOR === '1' ? 'background: lightblue' : item.Colors[0].ARR_COLOR === '2' ? 'background: pink' : item.Colors[0].ARR_COLOR === '3' ? 'background-color: gray' : item.Colors[0].ARR_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].ARR_COLOR === '5' ? 'background: red' : item.Colors[0].ARR_COLOR === '6' ? 'background: orange':item.Colors[0].ARR_COLOR === '7' ? 'background: yellow' : item.Colors[0].ARR_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].ARR_COLOR === '9' ? 'background: teal' : item.Colors[0].ARR_COLOR === '10' ? 'background: gold' :'background: white') : 'background: white'">
            {{item.Flights[0].ARR}}
          </td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STD.substring(11,16)}}</td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STA.substring(11,16)}}</td>
          <td style="font-weight: bold; border: 1px solid black; color: darkred;"></td>
          <td colspan="6"  @click="prepareEdit(item)" style="cursor: pointer;">
            <table v-for="(crew,index) in item.CrewGroups" :key="index">
              <tr>
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black;color: white;color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black;border-bottom: 1px solid black;" v-for="(el,j) in crew" :key="j + item.ID + 15952">{{el.CREW}}</td>
              </tr>
            </table>
            <table v-for="(manual,index) in item.CrewManualGroups" :key="index + 84164589">
              <tr style="border-top: 1px solid black;">
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black; color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black; border-bottom: 1px solid black; font-style: italic;" v-for="(el,j) in manual" :key="j + item.ID + 481426"><i class="icon icon-pencil"></i> {{el.FULLNAME}}</td>
              </tr>
            </table>
            <table :style="!item.CrewGroups[0] ? 'width: 50%' : ''">
              <tr>
                <td :colspan="!item.CrewGroups[0] ? 4 : 1" style="width: 165px; text-align: start; vertical-align: middle; height: 45px; border-right: 1px solid black; border-top: 1px solid black;border-bottom: 1px solid black; font-style: italic; font-size: 14px" v-for="(remark,index) in item.Remarks" :key="index"><i class="icon icon-pencil"></i> {{remark.REMARK}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="height: 50px; font-size: 18px; font-family: NunitoBold;vertical-align: middle;text-align: center">
          <td colspan="6" style="background-color: antiquewhite;border: 1px solid black">TRAININGS</td>
          <td colspan="1"></td>

          <td colspan="7" style="background-color: antiquewhite;border: 1px solid black">CREW LIST / EKİP LİSTESİ</td>
        </tr>
        <tr style="font-size: 12px; height: 45px; border: 1px solid black; vertical-align: middle;text-align: center;" v-for="(item) in getData.filter(x => x.Flights[0].DATATYPE === '2' && (x.Flights[0].CODE.includes('TRN') || x.Flights[0].CODE.includes('TRAINING')))" :key="item.Flights[0].LEGNO">
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" :id="`${item.Flights[0].UNO}`" :style="!item.CrewGroups ? 'background: #ccdceb; cursor: pointer' : ''" @click="openModal(item)" >{{item.Flights[0].REG}} <strong :id="item.ID" class="d-none" style="background: none"></strong></td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].CODE}}</td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleDep($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].DEP_COLOR === '1' ? 'background: lightblue' : item.Colors[0].DEP_COLOR === '2' ? 'background: pink' : item.Colors[0].DEP_COLOR === '3' ? 'background-color: gray' : item.Colors[0].DEP_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].DEP_COLOR === '5' ? 'background: red' : item.Colors[0].DEP_COLOR === '6' ? 'background: orange':item.Colors[0].DEP_COLOR === '7' ? 'background: yellow' : item.Colors[0].DEP_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].DEP_COLOR === '9' ? 'background: teal' : item.Colors[0].DEP_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].DEP}}
          </td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleArr($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].ARR_COLOR === '1' ? 'background: lightblue' : item.Colors[0].ARR_COLOR === '2' ? 'background: pink' : item.Colors[0].ARR_COLOR === '3' ? 'background-color: gray' : item.Colors[0].ARR_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].ARR_COLOR === '5' ? 'background: red' : item.Colors[0].ARR_COLOR === '6' ? 'background: orange':item.Colors[0].ARR_COLOR === '7' ? 'background: yellow' : item.Colors[0].ARR_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].ARR_COLOR === '9' ? 'background: teal' : item.Colors[0].ARR_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].ARR}}
          </td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STD.substring(11,16)}}</td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STA.substring(11,16)}}</td>
          <td style="font-weight: bold; border: 1px solid black; color: darkred;"></td>
          <td colspan="6"  @click="prepareEdit(item)" style="cursor: pointer">
            <table v-for="(crew,index) in item.CrewGroups" :key="index">
              <tr>
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black;color: white;color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black;border-bottom: 1px solid black;" v-for="(el,j) in crew" :key="j + item.ID + 84126">{{el.CREW}}</td>
              </tr>
            </table>
            <table v-for="(manual,index) in item.CrewManualGroups" :key="index + 841326">
              <tr style="border-top: 1px solid black;">
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black; color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black; border-bottom: 1px solid black; font-style: italic;" v-for="(el,j) in manual" :key="j + item.ID + 8455"><i class="icon icon-pencil"></i> {{el.FULLNAME}}</td>
              </tr>
            </table>
            <table :style="!item.CrewGroups[0] ? 'width: 50%' : ''">
              <tr>
                <td :colspan="!item.CrewGroups[0] ? 4 : 1" style="width: 165px; text-align: start; vertical-align: middle; height: 45px; border-right: 1px solid black; border-top: 1px solid black;border-bottom: 1px solid black; font-style: italic; font-size: 14px" v-for="(remark,index) in item.Remarks" :key="index"><i class="icon icon-pencil"></i> {{remark.REMARK}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="height: 50px; font-size: 18px; font-family: NunitoBold;vertical-align: middle;text-align: center">
          <td colspan="6" style="background-color: antiquewhite;border: 1px solid black">POSITIONING</td>
          <td colspan="1"></td>
          <td colspan="7" style="background-color: antiquewhite;border: 1px solid black">CREW LIST / EKİP LİSTESİ</td>
        </tr>
        <tr style="font-size: 12px; height: 45px; border: 1px solid black; vertical-align: middle;text-align: center;" v-for="(item) in getData.filter(x => x.Flights[0].DATATYPE === '2' && x.Flights[0].CODE === 'POSITIONING')" :key="item.Flights[0].LEGNO">
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" :id="`${item.Flights[0].UNO}`" :style="!item.CrewGroups ? 'background: #ccdceb; cursor: pointer' : ''" @click="openModal(item)" >{{item.Flights[0].REG}} <strong :id="item.ID" class="d-none" style="background: none"></strong></td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].CARRIER}}-{{item.Flights[0].FNO}}</td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleDep($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].DEP_COLOR === '1' ? 'background: lightblue' : item.Colors[0].DEP_COLOR === '2' ? 'background: pink' : item.Colors[0].DEP_COLOR === '3' ? 'background-color: gray' : item.Colors[0].DEP_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].DEP_COLOR === '5' ? 'background: red' : item.Colors[0].DEP_COLOR === '6' ? 'background: orange':item.Colors[0].DEP_COLOR === '7' ? 'background: yellow' : item.Colors[0].DEP_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].DEP_COLOR === '9' ? 'background: teal' : item.Colors[0].DEP_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].DEP}}
          </td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleArr($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].ARR_COLOR === '1' ? 'background: lightblue' : item.Colors[0].ARR_COLOR === '2' ? 'background: pink' : item.Colors[0].ARR_COLOR === '3' ? 'background-color: gray' : item.Colors[0].ARR_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].ARR_COLOR === '5' ? 'background: red' : item.Colors[0].ARR_COLOR === '6' ? 'background: orange':item.Colors[0].ARR_COLOR === '7' ? 'background: yellow' : item.Colors[0].ARR_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].ARR_COLOR === '9' ? 'background: teal' : item.Colors[0].ARR_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].ARR}}
          </td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STD.substring(11,16)}}</td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STA.substring(11,16)}}</td>
          <td style="font-weight: bold; border: 1px solid black; color: darkred;"></td>
          <td colspan="6"  @click="prepareEdit(item)" style="cursor: pointer;">
            <table v-for="(crew,index) in item.CrewGroups" :key="index">
              <tr>
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black;color: white;color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black;border-bottom: 1px solid black;" v-for="(el,j) in crew" :key="j + item.ID + 541848">{{el.CREW}}</td>
              </tr>
            </table>
            <table v-for="(manual,index) in item.CrewManualGroups" :key="index + 8451">
              <tr style="border-top: 1px solid black;">
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black; color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black; border-bottom: 1px solid black; font-style: italic;" v-for="(el,j) in manual" :key="j + item.ID + 158826"><i class="icon icon-pencil"></i> {{el.FULLNAME}}</td>
              </tr>
            </table>
            <table :style="!item.CrewGroups[0] ? 'width: 50%' : ''">
              <tr>
                <td :colspan="!item.CrewGroups[0] ? 4 : 1" style="width: 165px; text-align: start; vertical-align: middle; height: 45px; border-right: 1px solid black; border-top: 1px solid black;border-bottom: 1px solid black; font-style: italic; font-size: 14px" v-for="(remark,index) in item.Remarks" :key="index"><i class="icon icon-pencil"></i> {{remark.REMARK}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="height: 50px; font-size: 18px; font-family: NunitoBold;vertical-align: middle;text-align: center">
          <td colspan="6" style="background-color: antiquewhite;border: 1px solid black">GROUND TRANSPORTS</td>
          <td colspan="1"></td>

          <td colspan="7" style="background-color: antiquewhite;border: 1px solid black">CREW LIST / EKİP LİSTESİ</td>
        </tr>
        <tr style="font-size: 12px; height: 45px; border: 1px solid black; vertical-align: middle;text-align: center;" v-for="(item) in getData.filter(x => x.Flights[0].DATATYPE === '2' && x.Flights[0].CODE === 'TRANSPORT')" :key="item.Flights[0].LEGNO">
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" :id="`${item.Flights[0].UNO}`" :style="!item.CrewGroups ? 'background: #ccdceb; cursor: pointer' : ''" @click="openModal(item)" >{{item.Flights[0].REG}} <strong :id="item.ID" class="d-none" style="background: none"></strong></td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].CARRIER}}-{{item.Flights[0].FNO}}</td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleDep($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].DEP_COLOR === '1' ? 'background: lightblue' : item.Colors[0].DEP_COLOR === '2' ? 'background: pink' : item.Colors[0].DEP_COLOR === '3' ? 'background-color: gray' : item.Colors[0].DEP_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].DEP_COLOR === '5' ? 'background: red' : item.Colors[0].DEP_COLOR === '6' ? 'background: orange':item.Colors[0].DEP_COLOR === '7' ? 'background: yellow' : item.Colors[0].DEP_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].DEP_COLOR === '9' ? 'background: teal' : item.Colors[0].DEP_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].DEP}}
          </td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleArr($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].ARR_COLOR === '1' ? 'background: lightblue' : item.Colors[0].ARR_COLOR === '2' ? 'background: pink' : item.Colors[0].ARR_COLOR === '3' ? 'background-color: gray' : item.Colors[0].ARR_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].ARR_COLOR === '5' ? 'background: red' : item.Colors[0].ARR_COLOR === '6' ? 'background: orange':item.Colors[0].ARR_COLOR === '7' ? 'background: yellow' : item.Colors[0].ARR_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].ARR_COLOR === '9' ? 'background: teal' : item.Colors[0].ARR_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].ARR}}
          </td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STD.substring(11,16)}}</td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STA.substring(11,16)}}</td>
          <td style="font-weight: bold; border: 1px solid black; color: darkred;"></td>
          <td colspan="6"  @click="prepareEdit(item)" style="cursor: pointer">
            <table v-for="(crew,index) in item.CrewGroups" :key="index">
              <tr>
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black;color: white;color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black;border-bottom: 1px solid black;" v-for="(el,j) in crew" :key="j + item.ID + 79155">{{el.CREW}}</td>
              </tr>
            </table>
            <table v-for="(manual,index) in item.CrewManualGroups" :key="index + 7846526">
              <tr style="border-top: 1px solid black;">
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black; color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black; border-bottom: 1px solid black; font-style: italic;" v-for="(el,j) in manual" :key="j + item.ID +87451"><i class="icon icon-pencil"></i> {{el.FULLNAME}}</td>
              </tr>
            </table>
            <table :style="!item.CrewGroups[0] ? 'width: 50%' : ''">
              <tr>
                <td :colspan="!item.CrewGroups[0] ? 4 : 1" style="width: 165px; text-align: start; vertical-align: middle; height: 45px; border-right: 1px solid black; border-top: 1px solid black;border-bottom: 1px solid black; font-style: italic; font-size: 14px" v-for="(remark,index) in item.Remarks" :key="index"><i class="icon icon-pencil"></i> {{remark.REMARK}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="height: 50px; font-family: NunitoBold; font-size: 18px;vertical-align: middle;text-align: center">
          <td colspan="6" style="background-color: antiquewhite;border: 1px solid black">OTHERS</td>
          <td colspan="1"></td>
          <td colspan="7" style="background-color: antiquewhite;border: 1px solid black">CREW LIST / EKİP LİSTESİ</td>
        </tr>
        <tr style="font-size: 12px; height: 45px; border: 1px solid black; vertical-align: middle;text-align: center;" v-for="(item) in getData.filter(x => x.Flights[0].DATATYPE === '2' && x.Flights[0].ITDTYPE !== 'S' && !x.Flights[0].CODE.includes('TRN') && !x.Flights[0].CODE.includes('TRAINING') && x.Flights[0].CODE !== 'POSITIONING' && x.Flights[0].CODE !== 'TRANSPORT')" :key="item.Flights[0].LEGNO">
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" :id="`${item.Flights[0].UNO}`" :style="!item.CrewGroups ? 'background: #ccdceb; cursor: pointer' : ''" @click="openModal(item)" >{{item.Flights[0].REG}} <strong :id="item.ID" class="d-none" style="background: none"></strong></td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].CODE}}</td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleDep($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].DEP_COLOR === '1' ? 'background: lightblue' : item.Colors[0].DEP_COLOR === '2' ? 'background: pink' : item.Colors[0].DEP_COLOR === '3' ? 'background-color: gray' : item.Colors[0].DEP_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].DEP_COLOR === '5' ? 'background: red' : item.Colors[0].DEP_COLOR === '6' ? 'background: orange':item.Colors[0].DEP_COLOR === '7' ? 'background: yellow' : item.Colors[0].DEP_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].DEP_COLOR === '9' ? 'background: teal' : item.Colors[0].DEP_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].DEP}}
          </td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" @click="customStyleArr($event, item)" :id="`${item.Flights[0].UNO}`" :style="item.Colors.length > 0 ? (item.Colors[0].ARR_COLOR === '1' ? 'background: lightblue' : item.Colors[0].ARR_COLOR === '2' ? 'background: pink' : item.Colors[0].ARR_COLOR === '3' ? 'background-color: gray' : item.Colors[0].ARR_COLOR === '4' ? 'background-color : lightgreen' : item.Colors[0].ARR_COLOR === '5' ? 'background: red' : item.Colors[0].ARR_COLOR === '6' ? 'background: orange':item.Colors[0].ARR_COLOR === '7' ? 'background: yellow' : item.Colors[0].ARR_COLOR === '8' ? 'background: mediumpurple' : item.Colors[0].ARR_COLOR === '9' ? 'background: teal' : item.Colors[0].ARR_COLOR === '10' ? 'background: gold' : 'background: white') : 'background: white'">
            {{item.Flights[0].ARR}}
          </td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STD.substring(11,16)}}</td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STA.substring(11,16)}}</td>
          <td style="font-weight: bold; border: 1px solid black; color: darkred;"></td>
          <td colspan="6"  @click="prepareEdit(item)" style="cursor: pointer;">
            <table v-for="(crew,index) in item.CrewGroups" :key="index">
              <tr>
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black;color: white;color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black;border-bottom: 1px solid black;" v-for="(el,j) in crew" :key="j + item.ID + 842163">{{el.CREW}}</td>
              </tr>
            </table>
            <table v-for="(manual,index) in item.CrewManualGroups" :key="index + 81445">
              <tr style="border-top: 1px solid black;">
                <td :style="el.STATUS === '1' ? 'text-decoration: line-through; background: black; color: white' : el.STATUS === '2' ? 'background: lightgreen' : ''" style="width: 165px; text-align: center; height: 45px; border-right: 1px solid black; border-bottom: 1px solid black; font-style: italic;" v-for="(el,j) in manual" :key="j + item.ID + 78421"><i class="icon icon-pencil"></i> {{el.FULLNAME}}</td>
              </tr>
            </table>
            <table :style="!item.CrewGroups[0] ? 'width: 50%' : ''">
              <tr>
                <td :colspan="!item.CrewGroups[0] ? 4 : 1" style="width: 165px; text-align: start; vertical-align: middle; height: 45px; border-right: 1px solid black; border-top: 1px solid black;border-bottom: 1px solid black; font-style: italic; font-size: 14px" v-for="(remark,index) in item.Remarks" :key="index"><i class="icon icon-pencil"></i> {{remark.REMARK}}</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr style="height: 50px; font-size: 18px; font-family: NunitoBold;vertical-align: middle;text-align: center">
          <td colspan="6" style="background-color: antiquewhite;border: 1px solid black">MANUAL ENTRIES</td>
          <td colspan="1"></td>

          <td colspan="7" style="background-color: antiquewhite;border: 1px solid black">CREW LIST / EKİP LİSTESİ</td>
        </tr>
        <tr style="font-size: 12px; height: 45px; border: 1px solid black; vertical-align: middle;text-align: center;" v-for="(item) in getData.filter(x => x.Flights[0].DATATYPE === '3')" :key="item.Flights[0].LEGNO">
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px" :style="!item.CrewGroups ? 'background: #ccdceb; cursor: pointer' : ''" >{{item.Flights[0].REG}} <strong :id="item.ID" class="d-none" style="background: none"></strong></td>
          <td :style="item.Flights[0].LAST_REVACTION_FLT === '3' ? 'background: yellow' : item.Flights[0].LAST_REVACTION_FLT ==='2' ? 'background: lightgreen' : 'background: white'" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].CARRIER}}-{{item.Flights[0].FNO}}</td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">
            {{item.Flights[0].DEP}}
          </td>
          <td :class="!isColorSent ? 'selectable' : ''" style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">
            {{item.Flights[0].ARR}}
          </td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STD.substring(11,16)}}</td>
          <td style=" border: 1px solid black;border-top: unset; cursor:pointer;font-weight: bold ;width: 50px">{{item.Flights[0].STA.substring(11,16)}}</td>
          <td style="font-weight: bold; border: 1px solid black; color: darkred;"></td>
          <td colspan="6"  @click="prepareManualModal(item)" style="cursor: pointer">
            <table>
              <tr>
                <td style="font-weight: bold; font-style: italic; min-width: 660px; text-align: left; height: 45px; border-right: 1px solid black">{{ item.Manual[0].CREW }}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import {GlobalFunctionAndStateMixin} from "../../utils/mixins.js";
import ManualModal from "../../components/ManualModal.vue"
export default {
  mixins: [GlobalFunctionAndStateMixin],
  components: {
    ManualModal
  },
  data() {
    return {
      dep: [],
      arr: [],
      DepArrColors: [],
      getData: [],
      getLastRevData: [],
      TodayTime: '',
      picked: null,
      showDate: null,
      selectedLEGNO: '',
      selectedUNO: '',
      selectedID: '',
      currentTicketID: '',
      lastRev: '',
      ListItems: [],
      employeeLVC: -99,
      search: '',
      manualCrew: [],
      isEmployeeChanged: false,
      ManualForm: {
        ID: 0,
        LEGNO: 0,
        IDEMPLOYEE : 0,
        FULLNAME : '',
        CREATEDT : '',
        MODIFYDT : '',
        DATAVER : 0
      },
      manualFormOthers: {
        ID: 0,
        UNO: 0,
        IDEMPLOYEE : 0,
        FULLNAME : '',
        CREATEDT : '',
        MODIFYDT : '',
        DATAVER : 0
      },
      remarkForms: {
        ID: 0,
        LEGNO: 0,
        REMARK: '',
        CREATEDT: '',
        MODIFYDT : '',
        DATAVER : 0
      },
      remarkOtherForms: {
        ID: 0,
        UNO: 0,
        REMARK: '',
        CREATEDT: '',
        MODIFYDT : '',
        DATAVER : 0
      },
      colorForms : [
        {

        }
      ],
      color: '',
      employee: '',
      Remark : '',
      selectedRemarkID: 0,
      isCrew : false,
      isColorSent: true,

      receivedData: [],
      selectedManualId: -1,

    }
  },

  mounted() {
    this.dateFormatter();
    this.getList();
    this.revisionNumber();
    this.getDataByChanged();
    this.TR2EN;
    //this.intervalFunc();
  },
  updated() {
    this.tableRows();
  },
  computed: {
    filteredData() {
      let filteredData = this.TR2EN;
      let text = '';
      if (this.search) {
        text = this.search.toUpperCase().replace('İ','I').replace('Ö', 'O').replace('Ü','U')
            .replace('Ş', 'S').replace('Ç', 'C').replace('Ğ','G')
        filteredData = filteredData.filter((row) => {
          return Object.values(row).some((value) => {
            return String(value).toUpperCase().includes(text.toUpperCase());
          });
        });
      }
      //console.log("filteredData", JSON.parse(filteredData));
      return filteredData;
    },
    getColor(){
      let color = '';
      color = this.color;
      return color;
    },
    TR2EN(){
      let newArr = [];
      newArr = JSON.parse(JSON.stringify(this.ListItems).replaceAll('İ','I').replaceAll('Ö', 'O').replaceAll('Ü','U')
          .replaceAll('Ş', 'S').replaceAll('Ç', 'C').replaceAll('Ğ','G'))
      return newArr;
    },
  },

  methods: {
/*    async intervalFunc(){
      setInterval(() => {
        console.log("timer ticked")
      },5000)
    },*/
    prepareManualModal(item){
      this.selectedManualId = item.Manual[0].ID;
      setTimeout(() => {
        this.$refs.childComponentRef.childMethod();
        let modal = document.getElementById("manualModal");
        modal.style.display = 'block';
      },500)
      
    },
    receiveDataFromChild(data) {
      this.receivedData = data;
    },
    changeChar(){
      this.search.replaceAll('İ','I').replaceAll('Ö', 'O').replaceAll('Ü','U')
          .replaceAll('Ş', 'S').replaceAll('Ç', 'C').replaceAll('Ğ','G');
    },
    sendRemark(){
      this.$forceUpdate();
      this.remarkForms.LEGNO = parseInt(this.selectedLEGNO);
      this.remarkForms.CREATEDT = this.splitDate(new Date()).formatted_Api;
      this.remarkForms.MODIFYDT = this.splitDate(new Date()).formatted_Api;
      this.remarkForms.REMARK = this.Remark;
      this.remarkForms.ID = this.selectedRemarkID;

      this.remarkOtherForms.UNO = parseInt(this.selectedUNO);
      this.remarkOtherForms.CREATEDT = this.splitDate(new Date()).formatted_Api;
      this.remarkOtherForms.MODIFYDT = this.splitDate(new Date()).formatted_Api;
      this.remarkOtherForms.REMARK = this.Remark;
      this.remarkOtherForms.ID = this.selectedRemarkID;


      //console.log(this.remarkForms);
      axios.post(this.selectedLEGNO !== '' && this.selectedLEGNO !== undefined ? process.env.VUE_APP_API_URL+'DAI/DutiesRemark/InsertOrUpdate' : process.env.VUE_APP_API_URL+'DAI/OtherDutiesRemark/InsertOrUpdate', this.selectedLEGNO !== '' && this.selectedLEGNO !== undefined ? this.remarkForms : this.remarkOtherForms)
          .then((response) => {
            console.log(this.remarkForms);
            console.log(response);
          })
          .catch(reason => {
            console.log(reason)
          })
      this.getList();
      
    },
    runParentMethod() {
      this.getList();
    },
    getList() {
      this.getData = [];
      this.getLastRevData = [];
      this.lastRev = '';
      let userName = JSON.parse(localStorage.getItem("user")).name;
      //this.selectedID = '';

      axios.get(process.env.VUE_APP_API_URL+'DAI/DailyDuties/GetAll', {params: {FDAY: this.splitDate(this.picked).formatted_Api, USERNAME : userName}})
          .then((response) => {
            console.log(response);
            let index = JSON.stringify(response).indexOf('TICKETID');
            let start = index + 12;
            let end   = start + 19;
            let ticketId = JSON.stringify(response).substring(start, end);
            console.log(response)
            this.getData = JSON.parse(response.data.jsondata);
            console.log(this.getData.filter(x=>x.Flights[0].DATATYPE === '3'));
            //console.log(this.getData.filter(x=>x.DATATYPE === '2' && (x.CODE !== 'TRAINING' && x.CODE !== 'SIMULATOR' && x.CODE !== 'TRANSPORT' && x.CODE !== 'POSITIONING')));

            this.currentTicketID = ticketId;
            //console.log(this.getData.filter(x=>x.Flights[0].LEGNO === "462816"))
            //console.log(this.getData.filter(x=>x.Flights[0].UNO === "453566"))
          })
          .catch(reason => {
            console.log(reason)
          })
    },
    revisionNumber(){
      setTimeout( () => {
        axios.get(process.env.VUE_APP_API_URL+'DAI/DailyDuties/GetRevSummary?FDAY='+ this.splitDate(this.picked).formatted_Api)
            .then((response)=> {
              console.log(response);
              //console.log(JSON.parse((response.data).jsondata));
              this.lastRev = response.data.jsondata !== '' ? JSON.parse(response.data.jsondata).length -1  : 0;
              //document.getElementById('revision-id').innerHTML = "REV." + this.lastRev;
              //console.log(document.getElementById('revision-id'))
              //console.log(this.lastRev);
              this.$forceUpdate();
            })
      }, 1500)
    },

    //******** ROW'A TIKLANDIĞINDA ÇALIŞAN FONKSİYON ********//
    prepareEdit(item) {
      try {
        console.log(item);
        this.manualCrew = [];
        for (let i = 0; i < item.CrewManualGroups.length; i++) {
          this.manualCrew[i] = item.CrewManualGroups[i];
        }
        this.manualCrew = [].concat.apply([], this.manualCrew);
        //if(item.CrewManualGroups.length) this.manualCrew = item.CrewManualGroups[0];
        console.log("legno: " + this.selectedLEGNO);
        if(this.selectedLEGNO !== '' && this.selectedLEGNO !== null)document.getElementById(this.selectedLEGNO).style.backgroundColor = 'white';
        if(this.selectedUNO !== '' && this.selectedUNO !== null) document.getElementById(this.selectedUNO).style.backgroundColor = 'white';
        if(this.selectedID !== '' && this.selectedID !== null) document.getElementById(this.selectedID).classList.add('d-none');
        this.selectedLEGNO = item.Flights[0].LEGNO;
        this.selectedUNO = item.Flights[0].UNO;
        this.selectedID = item.ID;
        if(item.Remarks) {
          this.Remark = item.Remarks.length >0 ? item.Remarks[0].REMARK : '';
          this.selectedRemarkID = item.Remarks.length>0 ? item.Remarks[0].REMARKID : 0;
          this.selectedRemarkID = parseInt(this.selectedRemarkID);
        }
        let element = document.getElementById(item.Flights[0].LEGNO)
        if(item.Flights[0].LEGNO) {
          element.style.backgroundColor = '#ffc107';
          element.style.cursor = 'pointer';
        }
        let elementManual = document.getElementById(item.Flights[0].UNO)
        if(item.Flights[0].UNO){
          elementManual.style.backgroundColor = '#ffc107';
          elementManual.style.cursor = 'pointer';
        }
        document.getElementById(item.ID).classList.remove("d-none");
        document.getElementById(item.ID).innerHTML = "Manual";
        this.$forceUpdate();
      }
      catch (ex) {
        console.log(ex)
      }

    },
    //******** LEG NO'YA TIKLANDIĞINDA AÇILAN MODAL **********//
    openModal(item) {
      this.isCrew = false;
      if(!item.CrewGroups.length){
        this.prepareEdit(item);
        this.isCrew = true;
      }
      let modal = document.getElementById("myModal");
      if (this.selectedLEGNO !== '' || this.selectedUNO !== '') {
        modal.style.display = "block";
        if(this.isEmployeeChanged){
          axios.get(process.env.VUE_APP_API_URL+'DAI/Employee/GetAll')
              .then((response) => {
                //console.log(response)
                localStorage.setItem('employeeData', JSON.parse(JSON.stringify(response.data.jsondata)))
                this.ListItems = JSON.parse(localStorage.getItem('employeeData')).ListItems;
                this.employeeLVC = this.ListItems[this.ListItems.length-1].DataverLVC;
                localStorage.setItem('lastDataVer', this.ListItems[this.ListItems.length-1].DataverLVC);
                //console.log(this.ListItems)
                this.isEmployeeChanged = false;
              })
              .catch(reason => {
                console.log(reason)
              })
        }
      }
    },
    closeModal() {
      try {
        let modal = document.getElementById("myModal");
        modal.style.display = "none";
        let element = document.getElementById(this.selectedLEGNO);
        if(element){
          if(this.isCrew){
          element.style.backgroundColor = '#ccdceb';
          }
        else{
          element.style.backgroundColor = 'white';
          element.style.cursor = 'unset';
          }
        }
        let elementManual = document.getElementById(this.selectedUNO);
        if(elementManual){
          elementManual.style.backgroundColor = 'white';
          elementManual.style.cursor = 'unset';
        }

        //console.log("selectedID"+this.selectedID);
        let selectedElem = document.getElementById(this.selectedID);
        if(selectedElem!=null){
          document.getElementById(this.selectedID).classList.add("d-none");
          document.getElementById(this.selectedID).innerHTML = "";
        }
        this.selectedLEGNO = '';
        this.selectedUNO = '';
        this.selectedID = '';
        this.$forceUpdate();
      }
      catch (ex) {
        console.log(ex)
      }
    },

    /////**** Employee ekleme foksiyonu ****//////
    sendData(item){
      console.log(item)
      let element = document.getElementsByClassName("employee-status")[0];
      this.ManualForm.FULLNAME         = item.Adi + " " + item.Soyadi;
      this.ManualForm.LEGNO            = parseInt(this.selectedLEGNO);
      this.ManualForm.IDEMPLOYEE       = item.ID;
      this.ManualForm.MODIFYDT         = this.splitDate(new Date()).formatted_Api;
      this.ManualForm.CREATEDT         = this.splitDate(new Date()).formatted_Api;

      console.log(this.ManualForm);
      this.manualFormOthers.FULLNAME   = item.Adi + " " + item.Soyadi;
      this.manualFormOthers.UNO        = parseInt(this.selectedUNO);
      this.manualFormOthers.IDEMPLOYEE = item.ID;
      this.manualFormOthers.MODIFYDT   = this.splitDate(new Date()).formatted_Api;
      this.manualFormOthers.CREATEDT   = this.splitDate(new Date()).formatted_Api;
      let api = this.selectedLEGNO !== '' && this.selectedLEGNO !== undefined && this.selectedLEGNO !== null ?  process.env.VUE_APP_API_URL+'DAI/DutiesManual/InsertOrUpdate' : process.env.VUE_APP_API_URL+'DAI/OtherDutiesManual/InsertOrUpdate'
      //console.log(api);
      console.log(this.selectedLEGNO);
      console.log(this.manualFormOthers);
      axios.post(api, this.selectedLEGNO !== '' && this.selectedLEGNO !== undefined && this.selectedLEGNO !== null ? this.ManualForm : this.manualFormOthers)
          .then(response => {
            //console.log(response)
            if(response.data.lastError === ''){
              element.classList.add('alert-success');
              element.innerHTML = "Employee added successfully !";
              element.classList.add('alert-block');
            }
            else {
              element.classList.add('alert-danger');
              element.innerHTML = "Employee cannot be added !";
              element.classList.add('alert-block');
            }
          })
          .catch(reason => {
            console.log(reason)
          })
      setTimeout(function() {
        element.classList.remove('alert-block');
        element.classList.remove('alert-success');
        element.classList.remove('alert-danger');
      }, 2500)
      this.getList();
      
    },

    /////**** Employee Silme Fonksiyonu ****//////
    deleteByID(item){
      let element = document.getElementsByClassName("delete-status")[0];
      let id = item.ID;
      console.log(id);
      let index = this.manualCrew.findIndex(x=>x.TLC === item.TLC);
      let api = this.selectedLEGNO !== '' && this.selectedLEGNO !== undefined && this.selectedLEGNO !== null ?  process.env.VUE_APP_API_URL+'DAI/DutiesManual/DeleteById?id=' : process.env.VUE_APP_API_URL+'DAI/OtherDutiesManual/DeleteById?id='
      axios.post(api + id)
          .then(response => {
            //console.log(response.data)
            if(response.data.lastError === ''){
              element.classList.add('alert-success');
              element.innerHTML = "Employee successfully deleted !";
              element.classList.add('alert-block');
              this.manualCrew.splice(index, 1);
            }
            else {
              element.classList.add('alert-danger');
              element.innerHTML = "Error on deleting employee !";
              element.classList.add('alert-block');
            }
          })
          .catch(reason => {
            console.log(reason)
          })
      setTimeout(function() {
        element.classList.remove('alert-block');
        element.classList.remove('alert-success');
        element.classList.remove('alert-danger');
      }, 2500)
      this.getList();
      
    },

    /////**** Employee tablosunun tamamını her seferinde çekmemek için versiyon kontrol eden fonksiyon ****////
    getDataByChanged(){
      let currentDataVer = JSON.parse(localStorage.getItem('lastDataVer'));
      this.ListItems = JSON.parse(localStorage.getItem('employeeData')) !== null ? JSON.parse(localStorage.getItem('employeeData')).ListItems : null;
      if(currentDataVer !== null){
        axios.get(process.env.VUE_APP_API_URL+'DAI/Employee/GetByChanged?Dataver='+currentDataVer)
            .then((response) => {
              //console.log(response);
              this.isEmployeeChanged = response.data.jsondata !== '';
              //this.ListItems = JSON.parse(localStorage.getItem('employeeData')).ListItems;
            })
      }
      else this.isEmployeeChanged = true;
    },

    /////**** Publish İşlemi yapılan fonksiyon ****//////
    publishForm() {
      let modal = document.getElementById('publish-modal');
      modal.style.display = 'block';
    },
    publishModalClose(){
      let modal = document.getElementById('publish-modal');
      modal.style.display = 'none';
    },
    publishConfirm(){
        this.getList();
        let element = document.getElementsByClassName("publish-status")[0];
        axios.post(process.env.VUE_APP_API_URL+'DAI/DailyDuties/Publish?TicketId='+ this.currentTicketID)
            .then(response => {
              console.log(response.data)
              if(response.data.lastError === ''){
                element.classList.add('alert-success');
                element.innerHTML = "New revision successfully published !";
                element.classList.add('alert-block');
              }
              else {
                element.classList.add('alert-danger');
                element.innerHTML = "Error on publishing the revision !";
                element.classList.add('alert-block');
              }
            })
            .catch(reason => {
              console.log(reason)
            })
        this.sendColors();
        //this.getList();

        this.revisionNumber();
        this.DepArrColors = [];
        this.$forceUpdate();
        this.publishModalClose();
        setTimeout(function() {
          element.classList.remove('alert-block');
          element.classList.remove('alert-success');
          element.classList.remove('alert-danger');
        }, 2500)
    },

    dateFormatter() {
      let date = (document.getElementById('date-picker').value);
      if (date.length < 5) {
        date = new Date().toLocaleDateString('es-CL');
      }
      let year = date.slice(6, 10);
      let month = date.slice(3, 5);
      let day = date.slice(0, 2);

      this.picked = year + "-" + month + "-" + day;
      this.showDate = this.picked.substring(8,10) + '-' + this.picked.substring(5,7) + '-' + this.picked.substring(0,4);
    },

    datePickerChanged() {
      
      this.getList();
      this.revisionNumber();
      this.DepArrColors = [];
      this.showDate = this.picked.substring(8,10) + '-' + this.picked.substring(5,7) + '-' + this.picked.substring(0,4);
    },

    tableRows() {
      try {
        let table = document.getElementById("daily-table");
        let id = "";
        let idFirst = table.rows[0];
        for (let i = 1; i<table.rows.length; i++) {
          let row = table.rows[i];
          id = row.id
          if (id !== idFirst && id !== "") {
            idFirst = id;
            row.style.borderTop = "5px solid red";
          }
        }
      }
      catch (exception) {
        console.log(exception);
      }
    },
    customStyleDep: function (event, item) {
      try {
        this.isColorSent = false;
        let colorIndex = this.color === 'lightblue' ? 1 : this.color === 'pink' ? 2 : this.color === 'gray' ? 3 : this.color === 'lightgreen' ? 4 :
            this.color === 'red' ? 5 : this.color === 'orange' ? 6 : this.color === 'yellow' ? 7 : this.color === 'mediumpurple' ? 8 : this.color === 'teal' ? 9: this.color === 'gold' ? 10 : 0;
        let objDep = {ID: 0,
          LEGNO: parseInt(event.currentTarget.id),
          DEP_COLOR: item.Colors.length ? parseInt(item.Colors[0].DEP_COLOR) : 0,
          ARR_COLOR: item.Colors.length ? parseInt(item.Colors[0].ARR_COLOR) : 0,
          CREATEDT: this.splitDate(new Date()).formatted_Api,
          MODIFYDT: this.splitDate(new Date()).formatted_Api,
          DATAVER : 0,
          TICKETID: this.currentTicketID,
          FDAY : this.splitDate(this.picked).formatted_Api
        }
        let objDep2 = {ID: 0,
          UNO: parseInt(item.Flights[0].UNO),
          DEP_COLOR: item.Colors.length ? parseInt(item.Colors[0].DEP_COLOR) : 0,
          ARR_COLOR: item.Colors.length ? parseInt(item.Colors[0].ARR_COLOR) : 0,
          CREATEDT: this.splitDate(new Date()).formatted_Api,
          MODIFYDT: this.splitDate(new Date()).formatted_Api,
          DATAVER : 0,
          TICKETID: this.currentTicketID,
          FDAY : this.splitDate(this.picked).formatted_Api
        }
        console.log(objDep);
        let targetId = event.currentTarget.id;
        console.log(targetId);
        console.log(this.color);
        console.log(event.currentTarget.style.backgroundColor)
        if (event.currentTarget.style.backgroundColor !== this.color && this.color !== '') {
          console.log(this.color)
          event.currentTarget.style.backgroundColor = this.color;
          this.$forceUpdate();
        }
        else if(this.color !== '') {
          event.currentTarget.style.backgroundColor = 'white';
        }
        let index = this.DepArrColors.findIndex(x=>x.LEGNO === parseInt(targetId));
        let index2 = this.DepArrColors.findIndex(x=>x.UNO === parseInt(targetId));
        if(item.Flights[0].LEGNO){
          if ((index === -1) && this.color !== '') {
          objDep.DEP_COLOR = colorIndex;
          console.log(objDep)
          if(event.currentTarget.style.backgroundColor === 'white'){
            objDep.DEP_COLOR = 0;
          }
          objDep.ID = item.Colors.length ? parseInt(item.Colors[0].COLORID) : 0;
          this.DepArrColors.push(objDep);
          this.$forceUpdate();
        } else if ((index > -1) && this.color !== '') {
            if(event.currentTarget.style.backgroundColor === 'white') {
              this.DepArrColors[index].DEP_COLOR = 0;
            }
            else {
              this.DepArrColors[index].DEP_COLOR = colorIndex;
            }
            this.$forceUpdate();
          }
        }
        else{
          if ((index2 === -1) && this.color !== '') {
          objDep2.DEP_COLOR = colorIndex;
          if(event.currentTarget.style.backgroundColor === 'white'){
            objDep2.DEP_COLOR = 0;
          }
          objDep2.ID = item.Colors.length ? parseInt(item.Colors[0].COLORID) : 0;
          this.DepArrColors.push(objDep2);
          this.$forceUpdate();
        } else if ((index2 > -1) && this.color !== '') {
            if(event.currentTarget.style.backgroundColor === 'white') {
              this.DepArrColors[index2].DEP_COLOR = 0;
            }
            else {
              this.DepArrColors[index2].DEP_COLOR = colorIndex;
            }
            this.$forceUpdate();
          }
        }

        //this.DepArrColors[index].ID = item.COLORLIST.length ? parseInt(item.COLORLIST[0].COLORID) : 0;
          axios.post(item.Flights[0].LEGNO ? process.env.VUE_APP_API_URL+'DAI/DutiesColor/InsertOrUpdate' : process.env.VUE_APP_API_URL+'DAI/OtherDutiesColor/InsertOrUpdate', this.DepArrColors)
              .then((response) => {
                console.log(response);
                this.isColorSent = true;
                console.log("isColor : " +this.isColorSent)
              })
              .catch(reason => {
                console.log(reason)
              })

      }
      catch (exception) {
         console.log(exception);
      }
    },
    customStyleArr(event, item) {
      try {
        this.isColorSent = false;
        let colorIndex = this.color === 'lightblue' ? 1 : this.color === 'pink' ? 2 : this.color === 'gray' ? 3 : this.color === 'lightgreen' ? 4 :
            this.color === 'red' ? 5 : this.color === 'orange' ? 6 : this.color === 'yellow' ? 7 : this.color === 'mediumpurple' ? 8 : this.color === 'teal' ? 9: this.color === 'gold' ? 10 : 0;

        let objDep = {ID: 0,
          LEGNO: parseInt(event.currentTarget.id),
          DEP_COLOR: item.Colors.length ? parseInt(item.Colors[0].DEP_COLOR) : 0,
          ARR_COLOR: item.Colors.length ? parseInt(item.Colors[0].ARR_COLOR) : 0,
          CREATEDT: this.splitDate(new Date()).formatted_Api,
          MODIFYDT: this.splitDate(new Date()).formatted_Api,
          DATAVER : 0,
          TICKETID: this.currentTicketID,
          FDAY : this.splitDate(this.picked).formatted_Api
        }
        let objDep2 = {ID: 0,
          UNO: parseInt(item.Flights[0].UNO),
          DEP_COLOR: item.Colors.length ? parseInt(item.Colors[0].DEP_COLOR) : 0,
          ARR_COLOR: item.Colors.length ? parseInt(item.Colors[0].ARR_COLOR) : 0,
          CREATEDT: this.splitDate(new Date()).formatted_Api,
          MODIFYDT: this.splitDate(new Date()).formatted_Api,
          DATAVER : 0,
          TICKETID: this.currentTicketID,
          FDAY : this.splitDate(this.picked).formatted_Api
        }
        let targetId = event.currentTarget.id;
        if (event.currentTarget.style.backgroundColor !== this.color && this.color !== '') {
          event.currentTarget.style.backgroundColor = this.color;
        }
        else if(this.color !== '') {
          event.currentTarget.style.backgroundColor = 'white';
        }
        let index = this.DepArrColors.findIndex(x=>x.LEGNO === parseInt(targetId));
        let index2 = this.DepArrColors.findIndex(x=>x.UNO === parseInt(targetId));
        if(item.Flights[0].LEGNO){
          if ((index === -1) && this.color !== '') {
          objDep.ARR_COLOR = colorIndex;
          console.log(objDep)
          if(event.currentTarget.style.backgroundColor === 'white'){
            objDep.ARR_COLOR = 0;
          }
          objDep.ID = item.Colors.length ? parseInt(item.Colors[0].COLORID) : 0;
          this.DepArrColors.push(objDep);
          this.$forceUpdate();
        } else if ((index > -1) && this.color !== '') {
            if(event.currentTarget.style.backgroundColor === 'white') {
              this.DepArrColors[index].ARR_COLOR = 0;
            }
            else {
              this.DepArrColors[index].ARR_COLOR = colorIndex;
            }
          }
        }
        else{
          if ((index2 === -1) && this.color !== '') {
          objDep2.ARR_COLOR = colorIndex;
          if(event.currentTarget.style.backgroundColor === 'white'){
            objDep2.ARR_COLOR = 0;
          }
          objDep2.ID = item.Colors.length ? parseInt(item.Colors[0].COLORID) : 0;
          this.DepArrColors.push(objDep2);
          this.$forceUpdate();
        } else if ((index2 > -1) && this.color !== '') {
            if(event.currentTarget.style.backgroundColor === 'white') {
              this.DepArrColors[index2].ARR_COLOR = 0;
            }
            else {
              this.DepArrColors[index2].ARR_COLOR = colorIndex;
            }
          }
        }
        //this.DepArrColors[index].ID = item.COLORLIST.length ? parseInt(item.COLORLIST[0].COLORID) : 0;
          this.$forceUpdate();
          axios.post(item.Flights[0].LEGNO ? process.env.VUE_APP_API_URL+'DAI/DutiesColor/InsertOrUpdate' : process.env.VUE_APP_API_URL+'DAI/OtherDutiesColor/InsertOrUpdate', this.DepArrColors)
                  .then((response) => {
                    console.log(response);
                    this.isColorSent = true;
                  })
                  .catch(reason => {
                    console.log(reason)
                  })
      }
      catch (exception) {
        console.log(exception);
      }
    },
    openManualModal(){
      this.selectedManualId = -1;
      let modal = document.getElementById("manualModal");
      modal.style.display = 'block';
    },
    sendColors(){
/*      this.getList();
      console.log("DEPARR")
      axios.post( process.env.VUE_APP_API_URL+'DAI/DutiesColor/InsertOrUpdate', this.DepArrColors)
          .then((response) => {
            console.log(response);
          })
          .catch(reason => {
            console.log(reason)
          })
      axios.post(  process.env.VUE_APP_API_URL+'DAI/OtherDutiesColor/InsertOrUpdate', this.DepArrColors)
          .then((response) => {
            console.log(response);
          })
          .catch(reason => {
            console.log(reason)
          })*/
    },
  },
}


</script>

<style scoped>
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  padding-bottom: 65px;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.add-member {
  margin-top: -4px;
  line-height: normal;
}
.alert{
  display: none;
  position: fixed;
  top: 20px;
  right: 20px;
}
.alert-block{
  display: block;
  transition: all 2s linear;
}
#status-1{
  background-color: black;
  color: white;
}
#status-2{
  background-color: lightgreen;
}
#status-3{
  background-color: orange;
}
#status-4{
  background-color: white;
}
#date-picker{
  font-size: 16px;
  line-height: 2;
  height: 50px;
}
.publish-text{
  font-size: 16px;
}
.selectable{
  cursor: not-allowed !important;
  pointer-events: none;
}
.btn-manual-add{
  height: 50px;
}
</style>
